import React from 'react';
import {ManagementOverviewResponse, StationOverview} from '../types/ManagementOverviewReport.types';
import ReportHeader from './ReportHeader';
import ReportFooter from './ReportFooter';
import TechnicalDataPanel from './TechnicalDataPanel';
import PeriodTable from './PeriodTable';
import ReportCharts from './ReportCharts';
import PerformanceRatioGaugePanel from './PerformanceRatioGaugePanel';
import ReportSectionTitle from './ReportSectionTitle';

interface ManagementOverviewPageOneProps {
    report: ManagementOverviewResponse;
    station: StationOverview;
    showFullTitle: boolean;
    onChartReady?: (chartId: string) => void;
}

const ManagementOverviewPageOne: React.FC<ManagementOverviewPageOneProps> = ({
    report,
    station,
    showFullTitle,
    onChartReady,
}) => {
    const { referencePeriod } = report;

    return (
        <article
            className="report-page management-overview-page"
            data-page-kind="overview"
            data-station-id={station.stationId}
        >
            <ReportHeader
                customerName={report.customerName}
                referencePeriod={referencePeriod}
                generatedOn={report.generatedOn}
                stationName={station.stationName}
                showFullTitle={showFullTitle}
            />

            <div className="report-page__body">
                <TechnicalDataPanel
                    technicalData={station.technicalData}
                    stationName={station.stationName}
                />

                <section className="management-overview-period-layout avoid-break">
                    <ReportSectionTitle
                        aside={`${referencePeriod.month} ${referencePeriod.year}`}
                    >
                        Geração do Período
                    </ReportSectionTitle>
                    <div className="management-overview-period-layout__columns">
                        <div className="management-overview-period-layout__main">
                            <PeriodTable
                                table={station.monthlyTable}
                                variant="monthly"
                                stationName={station.stationName}
                                sectionAside={`Ano de ${referencePeriod.year}`}
                                hideSectionTitle
                            />
                            <PeriodTable
                                table={station.weeklyTable}
                                variant="weekly"
                                stationName={station.stationName}
                                hideSectionTitle
                            />
                        </div>
                        <PerformanceRatioGaugePanel
                            stationId={station.stationId}
                            performanceRatio={station.performanceRatio}
                            referencePeriod={referencePeriod}
                            onChartReady={onChartReady}
                        />
                    </div>
                </section>

                <ReportCharts
                    page="one"
                    stationId={station.stationId}
                    charts={station.charts}
                    referencePeriod={referencePeriod}
                    onChartReady={onChartReady}
                />
            </div>

            <ReportFooter customerName={report.customerName} generatedOn={report.generatedOn} />
        </article>
    );
};

export default ManagementOverviewPageOne;
